import { SELECIONAR_PEDIDO } from '../types'

export default function selecionarPedido (pedido) {
  return {
    type: SELECIONAR_PEDIDO,
    payload: pedido
  }
}
